import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'

import './index.scss'

document.addEventListener('DOMContentLoaded', function () {
  const root = document.getElementById('storl_academy_signup')
  if (!root) {
    return
  }

  ReactDOM.render(<App />, root)
})
